import { render, staticRenderFns } from "./EventPriceDetails.vue?vue&type=template&id=36c9438c&scoped=true&"
import script from "./EventPriceDetails.vue?vue&type=script&lang=js&"
export * from "./EventPriceDetails.vue?vue&type=script&lang=js&"
import style0 from "./EventPriceDetails.vue?vue&type=style&index=0&id=36c9438c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c9438c",
  null
  
)

export default component.exports